import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, Row, Col, CardBody, Table, CardTitle } from "reactstrap";
import { withTranslation } from 'react-i18next';
import PerfectScrollbar from 'react-perfect-scrollbar'

class MicronutrientsTableCard extends Component {

    render() {

        const { data, t } = this.props;

        let micronutrientsTable = null;
        if (data.length > 0) {
            micronutrientsTable = <PerfectScrollbar style={{ height: 'auto', maxHeight: '480px' }}>
                <Table className="tableFixHead">
                    <thead>
                        <tr>
                            <th><strong>{t("vitamins")}</strong></th>
                            <th><strong>{t("value")}</strong> ({t("per_person")})</th>
                            <th><strong>{t("unit")}</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((data, index) => {
                            return <tr key={index}>
                                <td>{t(data.vitaminName)}</td>
                                <td>{data.value}</td>
                                <td>{data.unit}</td>
                            </tr>
                        })}
                    </tbody>
                </Table>
            </PerfectScrollbar>
        }

        return (
            <Card className={'card-micronutrients'}>
                <CardHeader>
                    <CardTitle tag="h3"><strong>{t("vitamins")}</strong></CardTitle>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={12}>
                            {micronutrientsTable}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        )
    }
}

MicronutrientsTableCard.propTypes = {
    data: PropTypes.array.isRequired
}

export default withTranslation()(MicronutrientsTableCard);
